import { useBrandLogo } from '#app/utils/pz/brand/useBrandData'

interface LogoProps {
	className?: string
	imgClassName?: string
}

export const Logo: React.FC<LogoProps> = ({
	className = '',
	imgClassName = '',
}) => {
	const { logoSrc, handleLogoError, brandLogo } = useBrandLogo()
	const src = logoSrc ?? ''
	const alt = brandLogo?.alt ?? 'Logo'
	const wrapperClass = ['flex items-center space-x-2', className]
		.filter(Boolean)
		.join(' ')
	const imageClass = ['w-32 lg:w-36', imgClassName].filter(Boolean).join(' ')

	return (
		<div className={wrapperClass}>
			<img
				className={imageClass}
				src={src}
				alt={alt}
				onError={handleLogoError}
			/>
		</div>
	)
}
